import React from 'react';
import Loja from '~/components/Loja';
import { BuscaProduto } from '~/components/NovosInputs';
import ToggleDefault from '~/components/ToggleDefault';
import { useAjusteDeEstoque } from '../../hooks/useAjusteDeEstoque';
import { ButtonCancel } from '../../styles';
import { renderizarUnidade } from '../../utils/renderizarUnidade';

export const FormProduct: React.FC = () => {
  const {
    formTela: {
      register,
      control,
      setValue,
      watch,
      formState: { errors },
    },
    isUpdate,
    formDisabled,
    produto,
    isDisableSearch,
    isInvalidProduto,
    watchManterProduto,
    buscaPrdutoRef,
    handleLoja,
    handleAddProduto,
    handleDeleteProduto,
    formatNumber,
  } = useAjusteDeEstoque();

  const codLoja = watch('cod_loja');
  const desProduto = watch('des_produto');
  const qtdEstoqueAnt = watch('qtd_estoque_ant');

  return (
    <>
      <div id="containerloja" className="col-sm-12">
        <Loja
          selectedLoja={codLoja}
          IsInvalid={false}
          isDisabled={formDisabled.loja}
          onChange={(value: number) => {
            handleLoja(value);
          }}
        />
      </div>
      {!isUpdate && (
        <div
          style={{
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ width: '100%' }} ref={buscaPrdutoRef}>
            <BuscaProduto
              id="produtos"
              label="Buscar Produto *"
              placeholder="Selecione..."
              name="produtos"
              register={register}
              isError={!!errors.produtos}
              disabled={isDisableSearch || isUpdate}
              control={control}
              buscaNasLojas={[Number(codLoja)]}
              customOptions={{
                hideBuscarPor: true,
                buscarPor: ['Produto'],
                showSelecionarItensContendo: false,
              }}
              getProduct={(selected: any) => {
                handleAddProduto(selected);
              }}
              style={{ width: '100%' }}
              setValue={setValue}
            />
          </div>
          <div>
            <ButtonCancel
              type="button"
              disabled={!isDisableSearch}
              onClick={() => handleDeleteProduto()}
              style={{ marginTop: '1.875rem' }}
            >
              Cancelar
            </ButtonCancel>
          </div>
        </div>
      )}
      <div className="col-10 col-md-10">
        <table className={`table  ${isInvalidProduto ? 'isInvalid' : ''}`}>
          <thead>
            <tr>
              <th>Código</th>
              <th>Descrição</th>
              {!isUpdate ? <th>Est. Atual</th> : <th>Est. Anterior</th>}
              <th>Unid. Venda</th>
              <th>Unid. Compra</th>
              <th>Peso Variável?</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{produto?.cod_produto}</td>
              <td>
                <input
                  type="text"
                  disabled
                  value={
                    isDisableSearch && produto?.des_produto
                      ? produto.des_produto
                      : desProduto || ''
                  }
                />
              </td>
              {!isUpdate && isDisableSearch && (
                <td>
                  {produto?.qtd_est_atual.toString().includes('.')
                    ? formatNumber(produto?.qtd_est_atual)
                    : produto?.qtd_est_atual}
                </td>
              )}
              {isUpdate && !isDisableSearch && (
                <td style={{ maxWidth: '80px' }}>
                  {String(qtdEstoqueAnt).includes('.')
                    ? formatNumber(qtdEstoqueAnt)
                    : qtdEstoqueAnt}
                </td>
              )}
              <td style={{ maxWidth: '80px' }}>
                {renderizarUnidade(
                  produto,
                  'des_unidade_venda',
                  'qtd_embalagem_venda',
                )}
              </td>
              <td style={{ maxWidth: '80px' }}>
                {renderizarUnidade(
                  produto,
                  'des_unidade_compra',
                  'qtd_embalagem_compra',
                )}
              </td>
              <td style={{ maxWidth: '80px' }}>
                {produto ? (produto?.flg_ipv ? 'SIM' : 'NÃO') : ''}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {!isUpdate && (
        <div className="col-sm-2 col-md-2">
          <ToggleDefault
            labelText="Manter Produto?"
            onSwitch={() => setValue('manterProduto', !watchManterProduto)}
            setChecked={watchManterProduto}
          />
        </div>
      )}
    </>
  );
};
